import React, { type FC, type ReactElement } from 'react';
import { useRouter } from 'next/router';

import { thousandSeparated } from 'shared/util/formatting';
import type { Offer } from '@/interfaces';
import { trackClickOfferResult } from '../../tracking/FinnAnalytics';

export const Price: FC<Offer> = (offer): ReactElement<Offer> | null => {
    const { offerId, pricePerPerson } = offer;
    const router = useRouter();

    return pricePerPerson ? (
        <div>
            <a
                href={`${router.basePath}/ut?offerId=${offerId}&fromPage=result`}
                onClick={() => trackClickOfferResult(offer)}
                className="u-cb u-float-right button button--order button--small u-ph16 u-cb u-mb4 overlay__item_10"
                data-testid="offerLink"
                rel="noopener noreferrer nofollow"
                target="_blank">
                {`${thousandSeparated(pricePerPerson)} kr`}
            </a>
            <div className="text--extra-small u-text-right u-mr4 u-cb" data-testid="totalPrice">
                Totalt {thousandSeparated(pricePerPerson * 2)} kr
                <br />
                for 2 voksne
            </div>
        </div>
    ) : null;
};
